<template>
  <div class="wrap result-wrap">
    <div class="content">
      <template v-if="type === 'loading'">
        <div class="icon loading"></div>
        <div class="text">{{ $t('loginning') }}</div>
      </template>
      <template v-else-if="type === 'success'">
        <div class="icon success"></div>
        <div class="text">{{ $t('login_success_2') }}</div>
      </template>
      <template v-else-if="type === 'fail'">
        <div class="icon fail"></div>
        <div class="text">
          {{ $t('login_fail_2') }}
          <p class="code-tips" v-if="code > 0">{{ code }} - {{ $t(`PC_LOGIN_${code}`) }}</p>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { pushCodeToServer, pushCodeToOpenApi } from '@/api'
import vk2 from "@/oauth/social/vk2";
export default {
  name: 'CallBack',
  mixins: [vk2],
  data () {
    return {
      type: 'loading',
      code: 0,
      urlParams: {}
    }
  },
  created () {
    this.urlParams = this.getParams()
    // 社媒用户主动取消授权时直接展示失败页，避免继续调用 1067
    if (this.urlParams.error === 'access_denied') {
      this.type = 'fail'
      return
    }
    const state = this.getState()
    this.$i18n.locale = state.lang ? state.lang.replace('_', '-').toLowerCase() : 'en'
    this.pushCode(state)
  },
  methods: {
    getParams () {
      const search = window.getLocationSearch()
      const query = search.substring(1)
      const vars = query ? query.split('&') : []
      const params = {}
      vars.forEach(item => {
        const pair = item.split('=')
        params[pair[0]] = decodeURIComponent(pair[1])
      })
      return params
    },
    getState () {
      const stateStr = this.urlParams.state
      let state
      try {
        state = JSON.parse(decodeURIComponent(window.atob((decodeURIComponent(stateStr)))))
      } catch (error) {
        state = {}
      }
      return state
    },
    async pushCode (state) {
      const params = this.buildParams(state)
      if (params.s === 'vk' && this.urlParams.type === 'code_v2') {
        const state = this.getState()
        const res = await this.getGrantingPermissions(state)
        params.c = res.access_token
      }
      const api = state.use_open_api ? pushCodeToOpenApi : pushCodeToServer
      api(params).then(() => {
        this.type = 'success'
      }).catch(err => {
        this.type = 'fail'
        this.code = err.code
        err.code && this.$utils.customLog(err.code, params, err)
      })
    },
    buildParams (state) {
      let params = {
        p0: 'web',
        p1: 8,
        p2: 1067,
        p3: 'api',
        g: state.game,
        s: state.socialtype,
        t: state.clienttoken
      }
      // google token登录
      if (state.socialtype === 'google') {
        if (this.urlParams.access_token && this.urlParams.expires_in) {
          params = {
            ...params,
            c: decodeURIComponent(this.urlParams.access_token),
            e: parseInt(this.urlParams.expires_in),
            it: decodeURIComponent(this.urlParams.id_token)
          }
        }
        // 最新版
        if (this.urlParams.code) {
          params = {
            ...params,
            c: decodeURIComponent(this.urlParams.code),
            e: parseInt(this.urlParams.expires_in),
            it: decodeURIComponent(this.urlParams.id_token)
          }
        }
      } else if (state.socialtype === 'facebook') {
        if (this.urlParams.access_token && this.urlParams.expires_in) {
          params = {
            ...params,
            c: decodeURIComponent(this.urlParams.access_token),
            e: parseInt(this.urlParams.expires_in)
          }
        }
      } else if (state.socialtype === 'vk') {
        params = {
          ...params,
          c: decodeURIComponent(this.urlParams.access_token),
          e: 0
        }
      } else if (state.socialtype === 'discord') {
        params = {
          ...params,
          c: decodeURIComponent(this.urlParams.access_token),
          e: parseInt(this.urlParams.expires_in)
        }
        if (this.urlParams.code) params.c = decodeURIComponent(this.urlParams.code)
      } else if (state.socialtype === 'tt') {
        params = {
          ...params,
          c: decodeURIComponent(this.urlParams.code),
          ru: window.location.origin,
          cv: ''
        }
      } else if (state.socialtype === 'twitter') {
        params = {
          ...params,
          c: decodeURIComponent(this.urlParams.code),
          ru: window.location.origin,
          cv: 'challenge'
        }
      } else if (state.socialtype === 'line') {
        params = {
          ...params,
          c: decodeURIComponent(this.urlParams.code),
          ru: window.location.origin,
          cv: ''
        }
      } else {
        params = {
          ...params,
          c: decodeURIComponent(this.urlParams.access_token),
          e: parseInt(this.urlParams.expires_in)
        }
      }
      return params
    }
  }
}
</script>

<style lang='less' scoped >
.r-success {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  .icon {
    width: 51px;
    height: 51px;
    background: url(~@img/icon_success.png) center center no-repeat;
    background-size: 100% 100%;
  }
  .text {
    color: #111111;
    font-size: 18px;
    line-height: 18px;
    margin-top: 19px;
  }
}
.wrap {
  height: 100%;
  padding: 0 32px 20px;
  display: flex;
  flex-direction: column;
  .content {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .icon {
    width: 51px;
    height: 51px;
    background: url(~@img/icon_fail.png) center center no-repeat;
    background-size: 100% 100%;
    &.success { background-image: url(~@img/icon_success.png); }
    &.fail { background-image: url(~@img/icon_fail.png); }
    &.loading {
      background-image: url(~@img/icon_loading.png);
      filter: contrast(0.5);
      animation: infiniteRotate linear 2s infinite;
    }
  }
  .text {
    color: #111111;
    font-size: 18px;
    line-height: 18px;
    margin-top: 19px;
    text-align: center;
  }
  .code-tips {
    margin-top: 10px;
    font-size: 12px;
    line-height: 1.5;
    color: #777;
  }
}
@keyframes infiniteRotate {
  0% {
    transform: rotate(0);
  }
  50% {
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style> 
